module.exports = __webpack_public_path__ + "static/media/howItWorks_4.0d3eb022.svg";